import DashboardLayoutContainer from './DashboardLayout.container';

export default DashboardLayoutContainer;
